import { Box, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'ui/EasTable/types';
import { PaginationBlock } from 'ui/PaginationBlock';
import { PAGE_SIZE } from 'services/constants/env';
import { EasTable } from '../EasTable';
import { EasTableFilterPanel } from '../EasTableFilterPanel';
import { TEasTableWithFilterProps } from './types';
import { COLORS } from '../../services/constants/colors';

export const EasTableWithoutFilter = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows,
	highlightedRow,
	disabledRowFn,
	children,
	filterChildren,
	name,
	onTableStructureChange,
	emFilter = false,
	footerChildren,
}: TEasTableWithFilterProps<T>) => {
	return (
		<Box>
			<Paper
				sx={{
					overflowX: 'auto',
				}}
			>
				<Box sx={{ width: 'auto', minWidth: '400px' }}>
					<Box sx={{ borderRadius: '12px' }}>
						{children && (
							<Box
								sx={{
									backgroundColor: COLORS.BACKGROUND_SECONDARY,
									p: 0.5,
								}}
							>
								{children}
							</Box>
						)}
						<EasTable<T>
							tableStructure={tableStructure}
							items={items?.data ?? []}
							itemsIsLoading={itemsIsLoading}
							handleAction={handleAction}
							handleLink={handleLink}
							skeletonRows={skeletonRows}
							highlightedRow={highlightedRow}
							disabledRowFn={disabledRowFn}
						/>
					</Box>
					{footerChildren && <Box>{footerChildren}</Box>}
				</Box>
			</Paper>
		</Box>
	);
};
